import React from "react"
import DashboardLayoutV2 from "core/layouts/DashboardLayoutv2"
import Toast from "core/components/Toast"
import ProgressMeetViewModel from "./ProgressMeetViewModel"
import UpcomingSessionTable from "./components/UpcomingSessionTable"
import PastSessionTable from "presentation/Student/ProgressMeet/components/PastSessionTable"
import ButtonGroup from "core/components/v2/ButtonGroup"
import { STR_PAST_SESSIONS_AND_ASSIGNMENT, STR_UPCOMING_LECTURES } from "core/constants/strings"
import AttendanceFailureModal from "../Course/components/AttendanceFailureModal"

export default function ProgressMeetView() {
  const {
    toast,
    setActiveButtonType,
    changeActiveButtonType,
    activeButtonType,
    changeToastVisibility,
    getAllProgressMeets,
    allProgressMeet,
    setAllProgressMeet,
    progressMeetLink,
    filterSessions,
    upComingSession,
    pastSession,
    captureProgressMeetAtendance,
    waitingTime,
    handleJoinNow,
    attendanceFailure,
    setAttendanceFailure,
    currentClassLink,
  } = ProgressMeetViewModel()

  React.useEffect(() => {
    async function fetchProgressMeets() {
      await getAllProgressMeets()
    }
    fetchProgressMeets()
  }, [])

  React.useEffect(() => {
    if (allProgressMeet.length > 0) {
      filterSessions()
    }
  }, [allProgressMeet])

  return (
    <DashboardLayoutV2>
      <div className="p-[1.75rem]">
        <div className="">
          <h2 className="text-[#333] font-inter text-lg font-semibold leading-normal">Progress Meeting</h2>
          <p className="text-[#737373] font-inter text-sm font-normal leading-normal">
            Track your progress journey with your dedicated progress manager.
          </p>
        </div>
        <div className="  w-fit mt-4 ">
          <ButtonGroup
            className="w-fit rounded-[4px] p-[9px_16px]"
            buttons={[STR_UPCOMING_LECTURES, STR_PAST_SESSIONS_AND_ASSIGNMENT]}
            active={activeButtonType}
            onChange={changeActiveButtonType}
          />
        </div>
        {activeButtonType === 0 ? (
          <>
            <UpcomingSessionTable
              upcomingSessions={upComingSession}
              captureAttendance={captureProgressMeetAtendance}
              progressMeetLink={progressMeetLink}
            />
            <div className="mb-[79px] mt-4  flex w-full p-4 flex-col items-start gap-4 rounded-[8px] border border-[#D3D3D3] bg-white h-[370px]">
              <p className="mt-2  text-[#333] font-inter text-[16px] font-semibold">Progress Meeting Overview</p>
              <div className="mt-2   rounded-[4px] bg-[#F9F9F9] h-[298px] w-full p-[10px]">
                <p className=" text-[#646464] font-inter text-[14px] font-bold leading-[21px]">Purpose:</p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  A focused session to track performance, address challenges, and ensure continuous improvement.
                </p>
                <p className=" mt-3 text-[#646464] font-inter text-[14px] font-bold leading-[21px]">Agenda:</p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  Attendance Review: Track session and mentor meeting attendance.
                </p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  Topic Progress: Monitor covered topics and areas for improvement.
                </p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  {" "}
                  Exam Performance: Analyze scores and provide feedback.
                </p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  Mentor Sessions: Track engagement and participation.
                </p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  Feedback & Issue Resolution: Discuss concerns, suggestions, and improvements.
                </p>
                <p className=" mt-3 text-[#646464] font-inter text-[14px] font-bold leading-[21px]">Note:</p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-[150%]">
                  Regular participation supports growth, resolves issues, and drives academic success
                </p>
              </div>
            </div>
          </>
        ) : (
          <PastSessionTable pastSessions={pastSession} />
        )}
      </div>

      <Toast data={toast} onClick={() => changeToastVisibility(false)} />
    </DashboardLayoutV2>
  )
}
